module.exports = __webpack_public_path__ + "img/AdamSchieman.b1ae199d.jpeg";